let sizeSelected = null;
let klShow = 0;

function productDots() {
    const container = document.querySelector('.product__slider-points')
    const points = container.querySelector('.slider__point')
        if (container && points) {
        let initial = points?.cloneNode()
        while (container.hasChildNodes()) {
            container.removeChild(container.firstChild);
        }
        const images = document.querySelectorAll('.product__media-item.active:not(.hidden-mobile)')
        for (let i = 0;i < images.length; i++) {
            container.appendChild(initial.cloneNode())
        }
        const dots = document.querySelectorAll('.product__slider-points .slider__point')
        dots.forEach((dot) => {
            dot.classList.remove('active')
        })
        if (dots[0]) {
            dots[0].classList.add('active')
        }
        const slider = document.querySelector('.product__media-list')
        if (slider) {
            slider.addEventListener('scroll', () => {
                const dots = document.querySelectorAll('.product__slider-points .slider__point')
                const width = slider.offsetWidth
                const target = slider.scrollLeft / width
                if (dots[target] && !dots[target].classList.contains('active')) {
                    dots.forEach((dot) => {
                        dot.classList.remove('active')
                    })
                    dots[target].classList.add('active')
                }
            })
        }
    }
}

function klaviyoReviewObserve() {
    window.MutationObserver = window.MutationObserver
        || window.WebKitMutationObserver
        || window.MozMutationObserver;

    const configObs = {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
        attributeOldValue: true,
        characterDataOldValue: true
    };

    const observer = new MutationObserver(function (mutation) {
        mutation.forEach((item) => {
            if (item.target.classList && item.target.classList.contains('klaviyo-star-rating-widget')) {
                const target = document.querySelector('.kl_reviews__star_rating_widget')
                const string = target.getAttribute('aria-label')
                document.querySelector('.kl_reviews__star_rating_widget__label').textContent = string.replace(' stars, ', ' (').replace(' étoiles, ', ' (').replace(' reviews', ')').replace(' évaluations', ')')
                if (string.indexOf('0') === 0) {
                    target.classList.add('hidden')
                }
            }
        });
    })
    observer.observe(document, configObs);
}

function models() {
    const color = document.querySelector('.product-form__input[data-type="' + window.variantString.color + '"] input:checked')?.value.toLowerCase().replace(' ', '_')
    const images = document.querySelectorAll('.product__model-image img')
    images.forEach((img) => {
        if (img.src.indexOf(color) < 0) {
            img.classList.add('hidden')
        } else {
            img.classList.remove('hidden')
        }
    })
}

function switchCollaps() {
    const collaps = document.querySelectorAll('.product__collapsible-tab-item')
    const state = this.getAttribute('open')
    collaps.forEach((coll) => {
        coll.removeAttribute('open')
    })
    if (state === null) {
        this.setAttribute('open', '')
        const scrollToCollaps = this.getBoundingClientRect().top + window.scrollY - 60 - 80
        window.scrollTo(0, scrollToCollaps)
    }
}

function mobile() {
    if (window.innerWidth < 750) {
        // info wrapper
        let wrapper = document.querySelector('.default_product.product-v3 .product__info-wrapper')
        if (wrapper) {
            const target = document.querySelector('.slider-mobile-gutter')
            target.parentNode.insertBefore(wrapper, target.nextSibling);
        }
        // collapsible tab
        wrapper = document.querySelector('.default_product.product-v4 .product__collapsible-tab')
        if (wrapper) {
            const target = document.querySelector('.create-your-look__container')
            target?.parentNode.insertBefore(wrapper, target);
        }
        // size guide
        // wrapper = document.querySelector('.default_product.product-v3 .size-guide')
        // if (wrapper) {
        //     const target = document.querySelectorAll('.product-form__input[data-type=Taille], .product-form__input[data-type=Size]')[0]
        //     target.parentNode.insertBefore(wrapper, target.nextSibling);
        // }
        // rating under title
        let container = document.querySelector('.product__title .title__elements')
        if (container) {
            const target = document.querySelector('.klaviyo-star-rating-widget')
            if (container && target && container.parentNode !== target) {
                container.appendChild(target)
            }
        }
        // add to cart
        if (!document.querySelector('.product-form__buttons.sticky_add')) {
            let copy = document.querySelector('.product-form__buttons')?.cloneNode(true)
            if (copy) {
                copy.classList.add('hidden')
                copy.classList.add('sticky_add')
                const target = document.querySelector('section.default_product')
                if (copy && target && copy.parentNode !== target) {
                    target.appendChild(copy)
                    copy.addEventListener('click', () => {
                        const realButton = document.querySelector('.product-form__buttons:not(.sticky_add) button.product-form__submit')
                        realButton.click()
                    })
                }
            }
        }
    } else {
        let wrapper = document.querySelector('.default_product.product-v3 .product__info-wrapper')
        if (wrapper) {
            const target = document.querySelector('.product__media-wrapper')
            target.parentNode.insertBefore(wrapper, target.nextSibling);
        }
        // wrapper = document.querySelector('.default_product.product-v3 .size-guide')
        // if (wrapper) {
        //     const target = document.querySelectorAll('.product-form__input[data-type=Taille] legend.form__label, .product-form__input[data-type=Size] legend.form__label')[0]
        //     target.appendChild(wrapper);
        // }
        wrapper = document.querySelector('.product__tags')
        if (wrapper) {
            const target = document.querySelector('.klaviyo-star-rating-widget')
            if (target) {
                wrapper.parentNode.insertBefore(target, wrapper)
            }
        }
    }
}

function showVariantsSelectable(actual) {
    let height = !document.querySelector('section.product-pack') ? document.querySelector('input[name*="'+window.variantString.height+'"]:checked') : null
    if (height) {
        height = height.value
    }
    let options = []
    if (height) {
        for (const invQtyKey of Object.keys(inv_qty)) {
            if (inv_qty[invQtyKey].options.includes(height)) {
                inv_qty[invQtyKey].options.forEach((item) => {
                    options.push(item)
                })
            }
        }
        options = [...new Set(options)]
        if (options.length) {
            document.querySelectorAll('input[name*="'+window.variantString.color+'"]').forEach((item) => {
                if (!options.includes(item.value)) {
                    item.classList.add('hidden-variant')
                    document.querySelector('label[for="'+item.id+'"]').classList.add('hidden-variant')
                } else {
                    item.classList.remove('hidden-variant')
                    document.querySelector('label[for="'+item.id+'"]').classList.remove('hidden-variant')
                }
            })
        }
    }
}

function deliveryDate() {
    const delay = (window.lang === 'fr' ? 1 : 3)
    const interval = 2
    let start = new Date()
    let end = new Date()
    const options = {
        month: 'long',
        day: 'numeric',
    }
    if (start.getDay() === 0) {
        start.setTime(start.getTime() + (1 * 24 * 60 * 60 * 1000))
    }
    if (start.getDay() === 6) {
        start.setTime(start.getTime() + (2 * 24 * 60 * 60 * 1000))
    }
    start.setTime(start.getTime() + (delay * 24 * 60 * 60 * 1000))
    end.setTime(start.getTime() + (interval * 24 * 60 * 60 * 1000))
    if (start.getDay() > 2) {
        end.setTime(end.getTime() + (2 * 24 * 60 * 60 * 1000))
    }
    let container = document.querySelector('p.delivery__date')
    let inter = setInterval(() => {
        if (!container) {
            container = document.querySelector('p.delivery__date')
        }
        if (container) {
            clearInterval(inter)
            const startText = container.querySelector('.delivery__start')
            const endText = container.querySelector('.delivery__end')
            startText.textContent = start.toLocaleDateString(window.lang === 'fr' ? 'fr-FR' : 'en-GB', options)
            endText.textContent = end.toLocaleDateString(window.lang === 'fr' ? 'fr-FR' : 'en-GB', options)
        }
    }, 50)
}

function switchTags() {
    const container = document.querySelector('.tags__pop-up')
    if (!container.getAttribute('open')) {
        container.setAttribute('open', '')
    }
    const title = container.querySelector('.tags__text .text__title')
    const text = container.querySelector('.tags__text .text__paragraph')
    title.innerText = this.innerText
    text.innerText = this.dataset.text
}

function ranges() {
    // activities
    document.querySelectorAll('.product__ranges .range__value').forEach((range) => {
        onVisible(range, () => range.classList.add('visible'), () => range.classList.remove('visible'));
        respondToVisibility(range, (isVisible) => {
            if (isVisible) {
                range.classList.add('visible')
            } else {
                range.classList.remove('visible')
            }
        })
    })
    // temperature
    document.querySelectorAll('.product__ranges .temperature__range').forEach((range) => {
        onVisible(range, () => range.classList.add('visible'), () => range.classList.remove('visible'));
        respondToVisibility(range, (isVisible) => {
            if (isVisible) {
                range.classList.add('visible')
            } else {
                range.classList.remove('visible')
            }
        })
    })
    // temperature interval
    const container = document.querySelector('.product__ranges .temperature__range')
    if (container) {
        const start = container.dataset.valueStart
        const end = container.dataset.valueEnd
        const r = document.querySelector(':root')
        const maxWidth = container.offsetWidth
        r.style.setProperty('--temperature-start',  (parseInt(start) + 10) / 40 * maxWidth + 'px')
        r.style.setProperty('--temperature-end', ((parseInt(end) + 10) - (parseInt(start) + 10)) / 40 * maxWidth + 'px')
    }
}

/**
 * variant quantity updated
 */
function quantityUpdatedV3(actual) {
    showVariantsSelectable(parseInt(actual))
    if (typeof inv_qty !== 'undefined' && inv_qty[parseInt(actual)]) {
        let quantityLeft = document.querySelector('span.low-stock')
        const b2bQty = document.querySelector('.product-form__quantity span.stock')
        if (!b2bQty && quantityLeft) {
            if (inv_qty[actual].quantity < 5 && inv_qty[actual].quantity > 0) {
                quantityLeft.innerHTML = 'Plus que '+inv_qty[actual].quantity+' restant' +(parseInt(inv_qty[actual].quantity) > 1 ? 's' : '')
                quantityLeft.classList.add('active')
            } else {
                quantityLeft.classList.remove('active')
            }
        }
        if (b2bQty) {
            b2bQty.innerHTML = ' : '+inv_qty[actual].quantity+' restant' +(parseInt(inv_qty[actual].quantity) > 1 ? 's' : '')
        }
        const b2bSKU = document.querySelector('.product__sku span.value')
        if (b2bSKU) {
            b2bSKU.innerHTML = inv_qty[actual].sku
        }
        const b2bGTIN = document.querySelector('.product__gtin span.value')
        if (b2bGTIN) {
            b2bGTIN.innerHTML = inv_qty[actual].gtin
        }
    }
    models()
    packshot()
    swapProductImages()
    //b2bQuantityHide()
}

function packshot() {
    const color = document.querySelector('.product-form__input[data-type="' + window.variantString.color + '"] input:checked')?.value.toLowerCase().replace(' ', '_')
    const images = document.querySelectorAll('.product__text-image-item.packshot picture img')
    images.forEach((img) => {
        if (color && img.src.indexOf(color) < 0) {
            img.classList.add('hidden')
        } else {
            img.classList.remove('hidden')
        }
    })

}

function kleepPosition() {
    const kleepContainer = document.querySelector('.kleep-button')?.parentElement
    const target = document.querySelectorAll('legend[data-label="Taille"], legend[data-label="Size"]')[0]
    if (kleepContainer && target) {
        const sizeGuide = target.querySelector('.size-guide')
        if (sizeGuide) {
            target.insertBefore(kleepContainer, sizeGuide)
        } else {
            target.appendChild(kleepContainer)
        }
    }
}

function closeTagsPopUp() {
    this.parentElement.parentElement.removeAttribute('open')
}

function tags() {
    const tags = document.querySelectorAll('.tags__title')
    tags.forEach((item) => {
        item.addEventListener('click', switchTags.bind(item))
    })
    const closeTag = document.querySelector('.tags__pop-up .tags__close')
    if (closeTag) {
        closeTag.addEventListener('click', closeTagsPopUp.bind(closeTag))
    }
    const closeBackground = document.querySelector('.tags__pop-up .tags__background')
    if (closeBackground) {
        closeBackground.addEventListener('click', closeTagsPopUp.bind(closeTag))
    }
}

function collaps() {
    if (window.innerWidth <= 749) {
        const collaps = document.querySelectorAll('.product__collapsible-tab-item')
        collaps.forEach((item) => {
            item.addEventListener('click', switchCollaps.bind(item))
            item.addEventListener('tap', switchCollaps.bind(item))
        })
    } else {
        const collaps = document.querySelectorAll('.product__collapsible-tab__menu p')
        collaps.forEach((item) => {
            item.addEventListener('click', () => {
                collaps.forEach((p) => {
                    p.classList.remove('active')
                })
                item.classList.add('active')
                const coll = document.querySelectorAll('.product__collapsible-tab-item')
                coll.forEach((div) => {
                    div.removeAttribute('open')
                })
                const tabTarget = item.parentElement.parentElement.querySelector('.product__collapsible-tab-item.'+item.classList[0])
                const state = tabTarget?.getAttribute('open')
                if (state === null) {
                    tabTarget?.setAttribute('open', '')
                }
            })
        })
    }
}

function initKlaviyo() {
    let target = document.querySelector('#klaviyo-reviews-all .kl_reviews__summary h2')
    const interval = setInterval(() => {
        if (!target) {
            target = document.querySelector('#klaviyo-reviews-all .kl_reviews__summary h2')
        }
        if (target) {
            target.classList.add('hidden')
            const h2 = document.createElement ("h2")
            h2.innerText = 'Avis clients'
            target.after(h2)
            clearInterval(interval)
        }
    }, 100)
}

function fixIOS17() {
    var version = []
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        version = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }

    if (version && version[0] && version[1] && version[0] === 17 && version[1] < 2) {
        const videos = document.querySelectorAll('li.media-video video')
        if (videos) {
            videos.forEach((video) => {
                video.setAttribute('controls', '')
            })
        }
    }
}

function buttons() {
    const button = document.querySelector('button.product-form__submit')
    const b2b = document.querySelector('body.b2b-customer')
    if (button && button.hasAttribute('disabled') && !b2b) {
        const bis = document.querySelector('button.bis-notification')
        if (bis) {
            bis.style.display = 'flex'
        }
    }
}

function selectedSizeVariant() {
    const size = document.querySelectorAll('input[name="Taille"]:checked, input[name="Size"]:checked')[0]
    if (size) {
        size.removeAttribute('checked')
    }
    const inputs = document.querySelectorAll('input[name="Taille"], input[name="Size"]')
    inputs.forEach((item) => {
        item.addEventListener('change', () => {
            const button = document.querySelectorAll('button.product-form__submit')
            if (button) {
                button.forEach((item) => {
                    item.classList.remove('no-size-selected')
                    item.removeAttribute('disabled')
                })
            }
            sizeSelected = true
        })
    })
    if (inputs.length) {
        const button = document.querySelectorAll('button.product-form__submit')
        if (button) {
            button.forEach((item) => {
                item.classList.add('no-size-selected')
                item.setAttribute('disabled', null)
            })
        }
    }
}

function customAddToCart() {
    const button = document.querySelector('button.product-form__submit')
    if (button) {
        button.addEventListener('click', () => {
            if (button.classList.contains('no-size-selected')) {
                event.stopPropagation()
                event.preventDefault()
                if (window.innerWidth <= 749) {
                    const target = document.querySelector('variant-radios')
                    if (target) {
                        target.scrollIntoView({block: "start", behavior: "smooth"})
                    }
                }
            }
        })
    }
}

function klReviews() {
    klShow += 5
    const total = (3 / 5) * klShow
    const string = '#MainContent #klaviyo-reviews-all .kl_reviews__reviews_list .kl_reviews__review_item:nth-child('+(total + 1)+')~.kl_reviews__review_item{display:none;}'
    let style = (function() {
        // Create the <style> tag
        let style = document.getElementById("KLStyle");
        style.sheet.deleteRule(0)
        return style;
    })();
    style.sheet.insertRule(string, 0);
}

function klInit() {
    const interval = setInterval(() => {
        const target = document.querySelector('.kl_reviews__load_more_button')
        if (target) {
            target.addEventListener('click', klReviews)
            klReviews()
            clearInterval(interval)
        }
    }, 50)
}

function b2bDefaultVariant() {
    const b2b = document.querySelector('body.b2b-customer')
    if (b2b) {
        const defaultSize = document.querySelectorAll('.product-form__input[data-type="Taille"] input[value="M"], .product-form__input[data-type="Size"] input[value="M"]')[0]
        if (defaultSize) {
            const label = document.querySelector('label[for="'+defaultSize.id+'"]')
            label.click()
        }
        const size = document.querySelectorAll('.product-form__input[data-type="Taille"], .product-form__input[data-type="Size"]')[0]
        if (!size) {
            const id = document.querySelector('input[type=hidden][name="id"]')
            if (id && id.value) {
                quantityUpdatedV3(id.value)
            }
        }
        //b2bQuantityHide()
    }
}

function b2bQuantityHide() {
    const b2b = document.querySelector('body.b2b-customer')
    if (b2b) {
        const threshold = 5
        let options = document.querySelectorAll('input:checked')
        const fieldset = document.querySelectorAll('fieldset.product-form__input')
        let color = document.querySelector('.product-form__input[data-type="' + window.variantString.color + '"] input:checked')
        color = color ? color.value : null
        let data = []
        if (color) {
            for (let index in inv_qty) {
                if (inv_qty[index].options.includes(color)) {
                    data.push(inv_qty[index])
                }
            }
        } else {
            data = inv_qty
        }
        const labels = document.querySelectorAll('fieldset label')
        labels.forEach((label) => {
            label.classList.remove('oos')
        })
        for (let index in data) {
            if (fieldset.length === 1) {
                if (options[0].nextElementSibling) {
                    if (data[index].quantity < threshold && !data[index].available) {
                        options[0].nextElementSibling.classList.add('hidden')
                    }
                }
            }
            if (fieldset.length === 2) {
                if (data[index].quantity < threshold && data[index].options[0] === options[0].value) {
                    const target = document.querySelector('input[value="' + data[index].options[1] + '"]+label')
                    if (target) {
                        target.classList.add('hidden')
                    }
                }
            }
            if (fieldset.length === 3) {
                if (data[index].quantity < threshold && data[index].options[0] === options[0].value && data[index].options[1] === options[1].value) {
                    const target = document.querySelector('input[value="' + data[index].options[2] + '"]+label')
                    if (target) {
                        target.classList.add('hidden')
                    }
                }
            }
        }
    }
}

function addToCartButton() {
    // scroll sticky to not sticky button - mobile
    if (window.innerWidth < 750) {
        // The checker
        const gambitGalleryIsInView = (el, threshold = 0) => {
            const scroll = window.scrollY || window.pageYOffset
            const boundsTop = el.getBoundingClientRect().top + scroll

            const viewport = {
                top: scroll,
                bottom: scroll + window.innerHeight,
            }

            const bounds = {
                top: boundsTop + threshold,
                bottom: boundsTop + el.clientHeight,
            }

            return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
                || (bounds.top <= viewport.bottom && bounds.top >= viewport.top);
        }

        // requestAnimationFrame
        const raf =
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            function (callback) {
                window.setTimeout(callback, 1000 / 60)
            }

        // Usage.
        let button = document.querySelector('.product-form__buttons:not(.sticky_add) .product-form__submit')
        let bis = document.querySelector('.bis-notification')
        let tester = document.querySelector('.product-form__buttons:not(.sticky_add)')
        let sizeGuide = document.querySelector('.size-guide')

        const handler = () => raf(() => {
            let sticky = document.querySelector('.product-form__buttons.sticky_add')
            let ekookie = document.querySelector('#ekookie .ek-mainButton')
            const chat = document.getElementById('chat-button')
            if (tester && gambitGalleryIsInView(tester, 0) || (sizeGuide && (sizeGuide.getBoundingClientRect().top - window.innerHeight > -40))) {
                if (button) {
                    button.parentElement.classList.add('no-sticky')
                }
                if (bis) {
                    bis.classList.add('no-sticky')
                }
                if (ekookie) {
                    ekookie.classList.remove('sticky-mode')
                }
                if (chat) {
                    chat.classList.remove('sticky-mode')
                }
                if (sticky) {
                    sticky.classList.add('hidden')
                }
            } else if (tester) {
                // if (button) {
                //     button.parentElement.classList.remove('no-sticky')
                // }
                if (bis) {
                    bis.classList.remove('no-sticky')
                }
                if (ekookie) {
                    ekookie.classList.add('sticky-mode')
                }
                if (chat) {
                    chat.classList.add('sticky-mode')
                }
                if (sticky) {
                    sticky.classList.remove('hidden')
                }
            }
        })
        handler()
        window.addEventListener('scroll', handler)
    }
}

function klarnaPosition() {
    const klarna = document.querySelector('klarna-placement')?.parentElement
    const sliderBuyButtons = document.querySelector('.reassurance-buy-buttons')
    if (klarna && sliderBuyButtons && klarna.querySelector('klarna-placement')) {
        const element = document.createElement('p')
        element.appendChild(klarna)
        sliderBuyButtons.appendChild(element)
    }
}

function loyolyPosition() {
    const loyoly = document.querySelector('.loy-product-point')?.parentElement
    const sliderBuyButtons = document.querySelector('.reassurance-buy-buttons')
    if (loyoly && sliderBuyButtons) {
        const element = document.createElement('p')
        element.appendChild(loyoly)
        sliderBuyButtons.appendChild(element)
    }
}

function completeYourLookGender() {
    const genders = ['men', 'women']
    const gender = localStorage.getItem('gender')
    let active
    if (gender) {
        const containers = document.querySelectorAll('.create-your-look .card__media')
        containers.forEach((container) => {
            active = false
            const images = container.querySelectorAll('img')
            images.forEach((img) => {
                if (img.dataset.alt.toLowerCase().indexOf('_'+genders[0]+'_') > 0
                    || img.dataset.alt.toLowerCase().indexOf('_'+genders[1]+'_') > 0) {
                    img.classList.add('hidden')
                    if (img.dataset.alt.toLowerCase().indexOf('_' + gender + '_') > 0
                        && !active) {
                        img.classList.remove('hidden')
                        img.src = img.dataset.src
                        img.srcset = img.dataset.srcset
                        active = true
                    }
                }
            })
        })
    }
}

/**
 * Update mobile images under CTA
 * Using variant images | need 4,5 & 6th image to be functional
 */
function swapProductImages() {
    const waiting = setInterval(() => {
        const color = document.querySelector('.product-form__input[data-type="' + window.variantString.color + '"] input:checked')?.value.toLowerCase().replace(' ', '_').replace('/', '_')
        const images = document.querySelectorAll('li.product__media-item.active .product__media img')
        if (color && images && images[0] && images[0].src.toLowerCase().indexOf(color.toLowerCase()) > 0) {
            clearInterval(waiting)
            const containers = document.querySelectorAll('.product__text-image .product__text-image-item picture img')
            let index = 3
            let found = false
            containers.forEach((container) => {
                found = false
                while (index < 20 && !found) {
                    images.forEach((img) => {
                        if (!found && img.src.indexOf('_'+index) > 0) {
                            container.srcset = img.srcset
                            container.src = img.src
                            found = true
                        }
                    })
                    index++
                }
            })
        }
    }, 50)
}

function bundleVariantTitle() {
    const sizes = document.querySelectorAll('fieldset.product-form__input[data-type*="'+window.variantString.size+'"]')
    for (let i = 0; i < sizes.length; i++) {
        if (i) {
            sizes[i].querySelectorAll('p.size-guide__text')?.forEach((item) => {
                item.classList.add('hidden')
            })
        }
    }
}

function bundleReviews() {
    bundleVariantTitle()
    const bundle = document.querySelector('.klaviyo-reviews-bundle')

    if (bundle) {
        const reviewsTitle = document.querySelectorAll('.klaviyo-reviews-bundle__item')
        const reviews = document.querySelectorAll('.klaviyo-reviews-all__bundle-item')

        if (reviewsTitle) {
            reviewsTitle[0]?.classList.add('reviewing')
        }
        if (reviews) {
            reviews[1]?.classList.add('hidden')
        }

        reviewsTitle.forEach((title) => {
            title.addEventListener('click', (e) => {
                e.preventDefault()
                e.stopPropagation()
                reviewsTitle.forEach((i) => {
                    i.classList.remove('reviewing')
                })
                title.classList.add('reviewing')
                reviews.forEach((i) => {
                    if (i.dataset.id === title.dataset.productId) {
                        i.classList.remove('hidden')
                    } else {
                        i.classList.add('hidden')
                    }
                })
            })
        })

        let interval = setInterval(() => {
            const reviewsText = document.querySelector('.kl_reviews__star_rating_widget__label')
            const allReviewValue = document.querySelectorAll('.kl_reviews__summary__stars__count')
            const medianValue = document.querySelectorAll('.kl_reviews__summary__average_value')
            let median = 0.00
            let allStar = 0.00
            let reviewAccountable = 0.00

            for (let i = 0; i < medianValue.length; i++) {
                if (parseFloat(medianValue[i].innerText) > 0) {
                    reviewAccountable = reviewAccountable + 1.00
                    median = median + (parseFloat(medianValue[i].innerText.replace(',','.'))*100)
                }
            }
            median = median / reviewAccountable
            allStar = parseInt(allReviewValue[0] ? (allReviewValue[0].querySelector('.kl_reviews__summary__stars__count') ? allReviewValue[0].querySelector('.kl_reviews__summary__stars__count').innerText.replace(/\D/g,'')*1 : allReviewValue[0].innerText.replace(/\D/g,'')*1) : 0)
                + parseInt(allReviewValue[1] ? (allReviewValue[1].querySelector('.kl_reviews__summary__stars__count') ? allReviewValue[1].querySelector('.kl_reviews__summary__stars__count').innerText.replace(/\D/g,'')*1 : allReviewValue[1].innerText.replace(/\D/g,'')*1) : 0)

            if (reviewAccountable) {
                if (reviewsText) {
                    reviewsText.innerText = (median/100)+' ('+(isNaN(allStar)?'-':allStar)+')'
                    clearInterval(interval)
                }
                const stars = document.querySelectorAll('.klaviyo-star-rating-widget .kl_reviews__empty_star')
                if (stars) {
                    for (let i = 0; i < parseInt(median/100); i++) {
                        stars[i].querySelector('path').style.fill = '#010f16'
                    }
                }
            }
        }, 2000)
    }
}

function initProduct() {
    const product = document.querySelector('.default_product')
    if (product) {
        //addToCartButton()
        //buttons()
        //deliveryDate()
        klaviyoReviewObserve()
        mobile()
        ranges()
        tags()
        collaps()
        initKlaviyo()
        fixIOS17()
        selectedSizeVariant()
        customAddToCart()
        klInit()
        b2bDefaultVariant()
        kleepPosition()
        showVariantsSelectable(null)
        klarnaPosition()
        loyolyPosition()
        models()
        packshot()
        swapProductImages()
        completeYourLookGender()
        bundleReviews()
    }
    const sneaker = document.querySelector('.product__sneaker')
    if (sneaker) {
        klarnaPosition()
        tags()
    }
}

document.addEventListener('DOMContentLoaded', initProduct)
window.addEventListener('resize', mobile)